import i18n from 'providers/i18n';

/* eslint-disable no-bitwise */

const getInitialsWorker = (name, cap = 2, stripNonCharacters = true) => (name || '')
  .split(/[\s,]+/)
  .map(el => el[0])
  .filter(v => !!v)
  .filter(c => !stripNonCharacters || /^\p{L}$/u.test(c))
  .slice(0, cap)
  .join('');

const getInitials = (name, cap = 2) => getInitialsWorker(name, cap, true) || getInitialsWorker(name, cap, false);

const normalizeSearch = value => value.normalize('NFD').replace(/\p{M}/gu, '').toLowerCase();

const searchStrings = ($needle, $haystack) => {
  const needle = (Array.isArray($needle) ? $needle : [$needle])
    .filter(v => !!v)
    .map(normalizeSearch);

  const haystack = (Array.isArray($haystack) ? $haystack : [$haystack])
    .filter(v => !!v)
    .map(normalizeSearch);

  if (needle.length === 0 || haystack.length === 0) {
    return false;
  }

  return needle.some(searchString => haystack.some(haystackString => haystackString.includes(searchString)));
};

// https://stackoverflow.com/a/52171480/1016777
const cyrb53 = (str, seed = 0) => {
  let h1 = 0xdeadbeef ^ seed;
  let h2 = 0x41c6ce57 ^ seed;
  for (let i = 0, ch; i < str.length; i++) {
    ch = str.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507);
  h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507);
  h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3266489909);

  return 4294967296 * (2097151 & h2) + (h1 >>> 0);
};

// Resolved per call so the sort follows the user's current locale.
const getSortLocales = () => [
  i18n.resolvedLanguage,
  'en',
  ...(i18n.options.supportedLngs || []).filter((l) => l !== 'cimode'),
].filter(Boolean);

const defaultStringSort = (a, b) => {
  const locales = getSortLocales();
  return String(a ?? '').localeCompare(String(b ?? ''), locales.length ? locales : undefined, { numeric: true, sensitivity: 'accent' });
};

export default {
  getInitials,
  searchStrings,
  cyrb53,
  defaultStringSort,
};
